import React from 'react'

import cmSection from '../../public/cm_section_thumbnail.jpg'
import cmSectionLabel from '../../public/cm_section_label.png'
import { VideoPlayer } from '../VideoPlayer'

const CmSectionMovie = () => {
  return (
    <section className="relative py-[60px] sp:py-[50px] bg-pink-m1">
      <img
        src={cmSectionLabel.src}
        alt="CM Section Label"
        className="absolute top-[50px] right-[750px] w-[120px] 
          2xl:top-[2vw] 2xl:right-[28vw] 2xl:w-[5vw]
          xl:top-[4.5vw] xl:right-[12.5vw] xl:w-[8vw]
          lg:top-[5vw] lg:right-[3vw] lg:w-[11vw]
          md:top-[3vw] md:right-[4vw] md:w-[13vw]
          sm:top-[2vw] sm:right-[2vw] sm:w-[18.5vw]
          max-[320px]:top-[4.5vw] max-[320px]:right-[2.5vw] max-[320px]:w-[19.5vw]"
      />
      <h2 className="text-[27px] font-bold mb-[20px] text-center tracking-[0.15em] sp:text-[18px]">
        あなたは
        <br />
        どのお仕事を試したい？
      </h2>
      <VideoPlayer
        title="CM動画"
        thumbnail={cmSection.src}
        src="https://player.vimeo.com/video/1041688074"
        videoID="cmSection"
      />
    </section>
  )
}

export default CmSectionMovie
